
import { React, useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Box, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';


const PrivacyPolicy = () => {
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();

    //scrolled to top and loading screen
    useEffect(() => {
        window.scrollTo(0, 0);
        const timer = setTimeout(() => {
            setLoading(false);
        }, 200);

        return () => clearTimeout(timer);
    }, []);

    const [searchParams] = useSearchParams();
    const section = searchParams.get('section') || '';

    useEffect(() => {
        if (section) {
            // Attempt to find the element immediately
            let element = document.getElementById(section);

            // If not found, wait briefly and try again
            if (!element) {
                const checkElement = setInterval(() => {
                    element = document.getElementById(section);
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                        clearInterval(checkElement); // Stop checking once found
                    }
                }, 100); // Check every 100ms

                // Cleanup interval
                return () => clearInterval(checkElement);
            } else {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [section]);


    const pageStyle = {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#f7fafc", // bg-gray-50
    };

    const mainStyle = {
        flex: "1 0 auto",
        marginTop: "4rem", // mt-16
        paddingLeft: "1rem", // px-4
        paddingRight: "1rem",
        paddingTop: "2rem", // py-8
        paddingBottom: "2rem",
        "@media (min-width: 640px)": {
            paddingLeft: "1.5rem", // sm:px-6
            paddingRight: "1.5rem",
        },
        "@media (min-width: 1024px)": {
            paddingLeft: "2rem", // lg:px-8
            paddingRight: "2rem",
        },
    };

    const contentContainerStyle = {
        maxWidth: "70rem", // max-w-4xl
        marginLeft: "auto",
        marginRight: "auto",
    };

    const titleStyle = {
        fontSize: "1.875rem", // text-3xl
        fontWeight: "700", // font-bold
        marginBottom: "1.5rem", // mb-6
        textAlign: "center", // text-center
        "@media (min-width: 640px)": {
            fontSize: "2.25rem", // sm:text-4xl
        },
    };

    const sectionStyle = {
        display: "flex",
        flexDirection: "column",
        gap: "2rem", // space-y-8
    };

    const headerStyle = {
        fontSize: "1.25rem", // text-xl
        fontWeight: "600", // font-semibold
        color: "#2d4a4a", // from .privacy-header
        fontFamily: "'Inter', sans-serif",
        lineHeight: "1.3",
        marginBottom: "1rem", // mb-4
        transition: "color 0.3s ease",
        ":hover": {
            color: "#3b82f6", // from .privacy-header:hover
        },
        "@media (min-width: 640px)": {
            fontSize: "1.5rem", // sm:text-2xl
        },
    };

    const paragraphStyle = {
        fontSize: "1rem", // text-base
        color: "#6b7280", // from .privacy-paragraph
        fontFamily: "'Inter', sans-serif",
        lineHeight: "normal", // leading-relaxed
        marginBottom: "1.5rem",
        "@media (min-width: 640px)": {
            fontSize: "1.125rem", // sm:text-lg
        },
    };

    return (
        <div style={pageStyle}>
            <Navbar />
            {loading ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "100vh",
                    }}
                >
                    <Typography variant="h6" color="text.secondary">
                        <img
                            src="https://petpetclub.s3.ap-southeast-1.amazonaws.com/user-uploads/pets/68cb893a0feda12f2dbcc02b/68d4c8ce22baedfbe8b852dd.gif"
                            alt="Loading"
                            style={{
                                width: "150px",
                                height: "auto",
                                mixBlendMode: "multiply",
                            }}
                        />
                        <div
                            style={{
                                fontWeight: "500px",
                                fontSize: "15px",
                                textAlign: "center",
                                fontFamily: "Lucida Console",

                            }}>
                            {t('Loading')}
                        </div>
                    </Typography>
                </Box>
            ) : (
                <>
                    <main style={mainStyle}>
                        <div style={contentContainerStyle}>
                            <h1 style={titleStyle} className="text-green-600">
                                {t('PrivacyTitle')}
                            </h1>
                            <section style={sectionStyle}>
                                {/* Section 1 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t('Section1Title')}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t('Section1Content')}
                                        <br />
                                        <br />
                                        {t('Section1Content-1')}
                                    </p>
                                </div>
                                {/* Section 2 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t('Section2Title')}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t('Section2Content')}
                                    </p>
                                </div>
                                {/* Section 3 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t('Section3Title')}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t('Section3Content')}
                                        <div className="container px-4 pt-4">
                                            {t('Section3Content-1')}
                                            <br />
                                            <br />
                                            {t('Section3Content-2')}
                                        </div>
                                    </p>
                                </div>
                                {/* Section 4 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t('Section4Title')}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t('Section4Content')}
                                        <br /><br />
                                        {t('Section4Content-1')}
                                        <br /><br />
                                        {t('Section4Content-2')}
                                        <br /><br />
                                        {t('Section4Content-3')}
                                        <br /><br />
                                    </p>
                                </div>
                                {/* Section 5 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t('Section5Title')}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t('Section5Content')}
                                        <br /><br />
                                        {t('Section5Content-1')}
                                        <br />
                                        {t('Section5Content-2')}
                                        <br />
                                        {t('Section5Content-3')}
                                        <br /><br />
                                        {t('Section5Content-4')}
                                        <br /><br />
                                        {t('Section5Content-5')}
                                    </p>
                                </div>
                                {/* Section 6 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t('Section6Title')}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t('Section6Content')}
                                        <br />
                                        {t('Section6Content-1')}
                                        <br />
                                        {t('Section6Content-2')}
                                        <br />
                                        {t('Section6Content-3')}
                                        <br /><br />
                                        {t('Section6Content-4')}
                                        <br /><br />
                                        {t('Section6Content-5')}
                                    </p>
                                </div>
                                {/* Section 7 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t("Section7Title")}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t("Section7Content")}

                                        <br /><br />
                                        {t("Section7Content-1")}
                                        <br />
                                        {t("Section7Content-2")}
                                        <br />
                                        {t("Section7Content-3")}
                                        <br />
                                        {t("Section7Content-4")}
                                        <br />
                                        {t("Section7Content-5")}
                                        <br />
                                        {t("Section7Content-6")}
                                        <br />
                                        {t("Section7Content-7")}
                                        <br />
                                        {t("Section7Content-8")}
                                        <br />
                                        {t("Section7Content-9")}
                                        <br />
                                        {t("Section7Content-10")}
                                        <br /><br />

                                        {t("Section7Content-11")}
                                        <br />
                                        {t("Section7Content-12")}
                                        <br />
                                        {t("Section7Content-13")}
                                        <br />
                                        {t("Section7Content-14")}
                                        <br />
                                        {t("Section7Content-15")}
                                        <br />
                                        {t("Section7Content-16")}
                                        <br />
                                        {t("Section7Content-17")}
                                        <br />
                                        {t("Section7Content-18")}
                                        <br />
                                        {t("Section7Content-19")}
                                        <br />
                                        {t("Section7Content-20")}
                                        <br />
                                        {t("Section7Content-21")}
                                        <br />
                                        {t("Section7Content-22")}
                                        <br />
                                        {t("Section7Content-23")}
                                        <br />
                                        {t("Section7Content-24")}
                                        <br />
                                        {t("Section7Content-25")}
                                        <br />
                                        {t("Section7Content-26")}
                                        <br />
                                        {t("Section7Content-27")}
                                        <br />
                                        {t("Section7Content-28")}
                                        <br />
                                        {t("Section7Content-29")}
                                        <br /><br />

                                        {t("Section7Content-30")}
                                        <br /><br />

                                        {t("Section7Content-31")}
                                    </p>
                                </div>
                                {/* Section 8 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t("Section8Title")}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t("Section8Content")}
                                        <br /><br />
                                        {t("Section8Content-1")}
                                    </p>
                                </div>
                                {/* Section 9 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t("Section9Title")}
                                    </h2>
                                    <p style={paragraphStyle} id="second-section">
                                        {t("Section9Content")}
                                    </p>
                                </div>
                            </section>
                            <h1 style={titleStyle} className="container pt-4 text-green-600">
                                {t('PrivacyTitle-2')}
                            </h1>
                            <section style={sectionStyle}>
                                {/* Section 10 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t("Section10Title")}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t("Section10Content")}
                                    </p>
                                </div>
                                {/* Section 11 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t("Section11Title")}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        <div className="container px-4 pt-4">
                                            {t("Section11Content")}
                                            <br />
                                            {t("Section11Content-1")}
                                            <br /><br />
                                            {t("Section11Content-2")}
                                            <br />
                                            {t("Section11Content-3")}
                                            <br /><br />
                                        </div>
                                        {t("Section11Content-4")}
                                    </p>
                                </div>
                                {/* Section 12 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t("Section12Title")}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t("Section12Content")}
                                        <br /><br />
                                        {t("Section12Content-1")}
                                    </p> 
                                </div>
                                {/* Section 13 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t("Section13Title")}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t("Section13Content")}
                                        <br /><br />
                                        {t("Section13Content-1")}
                                        <br /><br />
                                        {t("Section13Content-2")}
                                    </p>
                                </div>
                                {/* Section 14 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t("Section14Title")}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t("Section14Content")}
                                        <br /><br />
                                        {t("Section14Content-1")}
                                        <br />
                                        {t("Section14Content-2")}
                                        <br />
                                        {t("Section14Content-3")}
                                    </p>
                                </div>
                                {/* Section 15 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t("Section15Title")}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t("Section15Content")}
                                        <br /><br />

                                        {t("Section15Content-1")}
                                        <br />
                                        {t("Section15Content-2")}
                                        <br />
                                        {t("Section15Content-3")}
                                        <br />
                                        {t("Section15Content-4")}
                                        <br />
                                        {t("Section15Content-5")}
                                    </p>
                                </div>
                                {/* Section 16 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t("Section16Title")}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t("Section16Content")}
                                        <br /><br />
                                        {t("Section16Content-1")}
                                        <br /><br />
                                        {t("Section16Content-2")}
                                    </p>
                                </div>
                                {/* Section 17 */}
                                <div>
                                    <h2 style={headerStyle}>
                                        {t("Section17Title")}
                                    </h2>
                                    <p style={paragraphStyle}>
                                        {t("Section17Content")}
                                        <br /><br />
                                        {t("Section17Content-1")}
                                    </p>
                                </div>

                                <div className="text-3xl sm:text-4xl font-bold text-green-600">{t('question')}</div>
                                <p style={paragraphStyle}>
                                    {t('questionInfo')}<a className="text-green-600 underline" href="mailto:info@ptag.com">info@ptag.com</a>
                                </p>
                            </section>
                        </div>
                    </main>
                </>
            )}
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
